import React from "react";
import "./App.css";
import Home from "../Home";
import Direct from "../Direct";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

const App = () => {

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/:hash">
          <Direct />
        </Route>
      </Switch>
    </Router >
  );
}

export default App;
